var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMicOn = function SvgMicOn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0007 1.33301C18.9462 1.33301 21.334 3.72082 21.334 6.66634V15.9997C21.334 18.9452 18.9462 21.333 16.0007 21.333C13.0551 21.333 10.6673 18.9452 10.6673 15.9997V6.66634C10.6673 3.72082 13.0551 1.33301 16.0007 1.33301ZM17.334 26.5838V27.9997H21.334V30.6663H10.6673V27.9997H14.6673V26.5838C9.40557 25.9277 5.33398 21.4392 5.33398 15.9997V13.333H8.00065V15.9997C8.00065 20.418 11.5824 23.9997 16.0006 23.9997C20.4189 23.9997 24.0006 20.418 24.0006 15.9997V13.333H26.6673V15.9997C26.6673 21.4392 22.5957 25.9277 17.334 26.5838ZM13.334 6.66634C13.334 5.19358 14.5279 3.99967 16.0007 3.99967C17.4734 3.99967 18.6673 5.19358 18.6673 6.66634V15.9997C18.6673 17.4724 17.4734 18.6663 16.0007 18.6663C14.5279 18.6663 13.334 17.4724 13.334 15.9997V6.66634Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MicOn.6a06bb4b.svg";
export { ForwardRef as ReactComponent };